export default {
    items: [
        {
            content_1: `
            <ul class="text-justify">
                <li>
                    <p class="mt-0 mb-0 text-justify">
                        พนักงานวิทยาลัยสายวิชาการ มีสิทธิลาพักผ่อนประจำปีโดยได้รับ เงินเดือนปีละไม่เกิน 10 วันทำการ 
                    </p>
                    <p class="mt-0 mb-0 text-danger text-justify">
                    *** เวันแต่กรณีที่เข้าปฏิบัติงานในปีแรก ยังไม่ครบ 6 เดือน ไม่มีสิทธิ์ลาพักผ่อนประจำปี ***
                    </p>
                    <p class="mt-0 mb-0 text-justify">กรณีใช้สิทธิลาพักผ่อนประจำปีแล้ว แต่ยังไม่ครบ 10 วันทำการ</p>
                    <p class="mt-0 mb-0 text-justify">สามารถสะสมวันที่ยังมิได้ลาในปีหนึ่ง ๆ รวมกับวันลาของปีต่อไปได้ แต่ไม่เกิน 20 วันทำการ</p>
                </li>
                <li>
                    <u>
                        พนักงานวิทยาลัยสายสนับสนุน</u> มีสิทธิลาพักผ่อนประจำปี โดยได้รับเงินเตือนตามกำหนด ดังนี้
                        <br>
                        <span class="text-dager">*** การนับอายุงานจะนับตามปีงบประมาณ ***</span>
                    <ul>
                        <li>อายุการทำงานครบ 6 เดือนในปีแรก มีสิทธิลาพักผ่อนประจำปี ได้ไม่เกิน 7 วันทำการ</li>
                        <li>อายุการทำงานครบ 1 ปีขึ้นไป แต่ไม่ถึง 5 ปี มีสิทธิลาพักผ่อน ประจำปีได้ 10 วันทำการ</li>
                        <li>อายุการทำงานครบ 5 ปีขึ้นไปแต่ไม่ถึง 10 ปี มีสิทธิลาพักผ่อนประจำปีได้ 12 วันทำการ</li>
                        <li>อายุการทำงานครบ 10 ขึ้นไป มีสิทธิลาพักผ่อนประจำปีได้ 15 วันทำการ</li>
                    </ul>
                </li>
                <li><u>การลาพักผ่อนประจำปี</u> จะไม่สามารถสะสมในปีถัดไปได้ และไม่มีการจ่ายชดเชย</li>
            </ul>`,
            content_2: `<ul>
                <li>กรณีปกติลาได้ไม่เกิน 60 วันทำการ</li>
                <li>
                    <p class="mt-0 mb-0">กรณีต้องพักรักษาตัวในโรงพยาบาล</p>
                    <p class="mt-0 mb-0">รักษาตัวต่อเนื่องตามความเห็นแพทย์ลาได้ไม่เกิน 60 วันทำการ/ปี</p>
                    <p class="mt-0 mb-0">รวมทั้งปีลาได้ 120 วันทำการ(ได้รับเงินเดือน)</p>
                <li>ลาเกิน 3 วันติดต่อกันต้องมีใบรับรองแพทย์</li>
            </ul>`,
            content_3: `<ul>
                <li>กรณีปกติลาได้ไม่เกิน 60 วันทำการ</li>
                <li>
                    <p class="mt-0 mb-0">กรณีต้องพักรักษาตัวในโรงพยาบาล</p>
                    <p class="mt-0 mb-0">รักษาตัวต่อเนื่องตามความเห็นแพทย์ลาได้ไม่เกิน 60 วันทำการ/ปี</p>
                    <p class="mt-0 mb-0">รวมทั้งปีลาได้ 120 วันทำการ(ได้รับเงินเดือน)</p>
                </li>
                <li>ลาเกิน 3 วันติดต่อกันต้องมีใบรับรองแพทย์</li>
            </ul>`,
            content_4: `ให้รองคณบดีต้นสังกัดพิจารณาตามความเหมาะสม`,
            content_5: `<p class="mt-0 mb-0 text-danger"> การลาครึ่งวัน จะไม่สามารถใช้สิทธิร่วมกับ Flexible time ในวันดังกล่าวได้ </p> <p class="mt-0 mb-0 text-dark"><strong>กรณีลาเช้า</strong> เวลาการปฏิบัติงานคือ 13.00 - 17.00 น.</p> <p class="mt-0 mb-0 text-dark"><strong>กรณีลาบ่าย</strong> เวลาการปฏิบัติงานคือ 08.00 - 12.00 น.</p>`,
            content_6: `<ul>
                <li>
                    <p class="mt-0 mb-0">พนักงานวิทยาลัยที่ยังไม่เคยลาอุปสมบทและประสงค์จะอุปสมบท</p>
                    <p class="mt-0 mb-0">หรือพนักงานวิทยาลัยที่นับถือศาสนาอิสลามซึ่งประสงค์จะลาไปประกอบพิธีฮัจย์ ณ เมืองเมกกะ ประเทศชาอุดิอาระเบียมีสิทธิลาอุปสมบท</p>
                    <p class="mt-0 mb-0">หรือไปประกอบพิธีฮัจย์ โดยได้รับเงินเดือนได้ไม่เกิน 120 วัน</p>
                </li>
                <li>พนักงานวิทยาลัยจะขอลาอุปสมบท หรือ ขอลาไปประกอบพิธีฮัจย์อย่างหนึ่งอย่างใดได้เพียงครั้งเดียว</li>
            </ul>`,
            content_7: `
            <ul>
                <li>ลาครั้งหนึ่งได้ไม่เกิน 90 วันโดยจะได้เงินเดือน 45 วันแรก</li>
                <li>
                    ดูแลบุตรและภรรยาหลังคลอด
                    <ul>
                        <li>ลาได้เฉพาะ พม./พส. ประเภทชาย</li>
                        <li>เป็นภรรยาที่ถูกต้องตามกฏหมาย</li>
                        <li>ลาได้ครั้งละไม่เกิน 15 วันทำการ (ได้รับเงินเดือนตามปกติ)</li>
                    </ul>
                </li>
            </ul>
            `,
            content_8: `ให้รองคณบดีต้นสังกัดพิจารณาตามความเหมาะสม`,
        }
    ]
}
